import axios from 'axios'

import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const { main, assigned, lists: { lists, user, edit }, filters, categories } = config.endpoints.pools

const getFilters = () => axios({
  method: 'get',
  url: filters,
  headers: getHeaders(true)
})

const mainUsers = (data) => axios({
  method: 'post',
  url: main,
  data,
  headers: getHeaders(true)
})

const assignedUsers = (data) => axios({
  method: 'post',
  url: assigned,
  data,
  headers: getHeaders(true)
})

const listsUsers = (data) => axios({
  method: 'post',
  url: lists,
  data,
  headers: getHeaders(true)
})

const listEdit = (data) => axios({
  method: 'post',
  url: edit,
  data,
  headers: getHeaders(true)
})

const getListsByUser = (userId) => axios({
  method: 'get',
  url: user.replace(':userId', userId),
  headers: getHeaders(true)
})

const getCategories = (data) => axios({
  method: 'post',
  url: categories,
  data,
  headers: getHeaders(true)
})

export default {
  getFilters,
  mainUsers,
  assignedUsers,
  listsUsers,
  listEdit,
  getListsByUser,
  getCategories,
}
